import { create } from 'zustand';
import type { User } from '@fintronners/react-api/src';

type UserDetails = Pick<User, 'id' | 'profile'> | null;

type AppStore = {
  // getters
  newApiUrl: string | null;
  tenant: string | null;
  userDetails: UserDetails;
  tenantSupportEmail: string | null;
  tenantSupportPhone: string | null;
  tenantSupportPage: string | null;

  // setters
  setNewApiUrl: (apiNewUrl: string) => void;
  setTenant: (tenant: string | null) => void;
  setUserDetails: (userDetails: UserDetails) => void;
  setTenantSupportEmail: (supportEmail: string) => void;
  setTenantSupportPhone: (supportPhone: string) => void;
  setTenantSupportPage: (supportPage: string) => void;
};

export const useAppStore = create<AppStore>((set) => ({
  // getters
  newApiUrl: null,
  tenant: null,
  userDetails: null,
  tenantSupportEmail: null,
  tenantSupportPhone: null,
  tenantSupportPage: null,
  // setters
  setNewApiUrl: (newApiUrl) => set({ newApiUrl }),
  setTenant: (tenant) => set({ tenant }),
  setUserDetails: (userDetails) => set({ userDetails }),
  setTenantSupportEmail: (tenantSupportEmail: string) => set({ tenantSupportEmail }),
  setTenantSupportPhone: (tenantSupportPhone: string) => set({ tenantSupportPhone }),
  setTenantSupportPage: (tenantSupportPage: string) => set({ tenantSupportPage }),
}));
